import { useEffect, useRef, useState } from "react";

import { getRoutesDirections } from "@/data/libraries/Routes"
import { useLocation, useNavigate, type NavigateFunction, Location, NavLink } from 'react-router-dom';
import { Col, Row, Image } from "react-bootstrap"

import { getCSSVariableValue } from "@/domain/utils/CssExtractVariable";
import { translate } from '@/domain/utils/translate';
import { blurButtonAfterClick } from "@/domain/utils/blurButtonAfterClick";

import Icon from "@/ui/assets/Icon"

import CartWidget from "@/ui/components/sales/CartWidget"
import SearchInput from "@/ui/components/store/SearchInput"

import LoginMenu from "@/ui/containers/Header/LoginMenu"
import Menu from "@/ui/containers/Header/Menu"
import { IFooterSections } from "@/domain/interfaces/IFooterSections";
import { useAppSelector } from "@/ui/store/helperRedux";
import { IStore } from "@/domain/interfaces/IStore";



interface ExclusiveHeaderProps {
    /** Logo de la aplicación */
    logo: string;
    /** Envía a Mis compras */
    goToPurchases: () => void;
    /** Identifica la expansión del componente */
    isExpanded: boolean;
    /** Maneja la expansión del componente */
    handleExpand: () => void;
    /** Maneja renderizado opciones de usuario  */
    handleShowOptionsUser: () => void;
    /** Maneja renderizado de carrito  */
    handleShowCartModal: () => void;
}

/**
 * Componente header versión EXCLUSIVE
 * @component
 */
const ExclusiveHeader = ({
    logo,
    goToPurchases,
    isExpanded,
    handleExpand,
    handleShowOptionsUser,
    handleShowCartModal,
}: ExclusiveHeaderProps): JSX.Element => {

    /** Hook para generar una navegación dentro de la aplicación. */
    const navigate: NavigateFunction = useNavigate();
    /** Hook para obtener la ubicación actual de la aplicación. */
    const location: Location = useLocation();
    /** Hook para obtener el valor de una variable CSS de los botones del header */
    const buttonVariant = getCSSVariableValue('--link-button-variant-header');

    /** Hook para obtener el valor de una variable CSS de los iconos del header */
    const iconVariant = getCSSVariableValue('--icon-variant-light');

    /** Rutas URLs */
    const routesDirections = getRoutesDirections();

    /** State Redux de datos de la tienda */
    const storeData = useAppSelector((state) => state.storeData) as IStore;

    /** State con la info a mostrar en el modal  */
    const [blogSection, setBlogSection] = useState<IFooterSections | null>(storeData.blog);

    /** Referencia al botón de la tienda */
    const storeButton = useRef<HTMLButtonElement>(null);
    /** Referencia al botón del blog */
    const blogButton = useRef<HTMLButtonElement>(null);
    /** Referencia al botón de mis compras */
    const purchasesButton = useRef<HTMLButtonElement>(null);

    /** Referencia al botón del carrito */
    const cartButton = useRef<HTMLButtonElement>(null);

    const handleClickStore = () => blurButtonAfterClick(storeButton, () => { navigate(routesDirections.STORE_ROUTE) });
    const handleClickBlog = () => blurButtonAfterClick(blogButton, () => { navigate(routesDirections.BLOG_ROUTE, { state: { blogSection } }) });
    const handleClickMyPurchases = () => blurButtonAfterClick(purchasesButton, goToPurchases);
    const handleCartClick = () => blurButtonAfterClick(cartButton, handleShowCartModal);

    // Desplazar al inicio de la página al montar el componente
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        setBlogSection(storeData.blog);
    }, [storeData]);

    /** Renderizado del componente */
    return (
        <Row className='g-0 mh-186-px'>

            <Col lg={12} >
                {isExpanded ? (
                    <>
                        <Col lg={12} className='d-flex justify-content-center align-items-center  my-4 '>
                            <NavLink to={routesDirections.MAIN_ROUTE} state={{ originURL: location.pathname }}>
                                <Image
                                    id='logo'
                                    src={logo}
                                    alt='logo'
                                    className='logo-header'
                                    onClick={() => {
                                        navigate(routesDirections.MAIN_ROUTE, { state: { originURL: location.pathname } });
                                    }}
                                />
                            </NavLink>
                        </Col>

                        <Col className='d-flex align-items-center align-items-center'>
                            <Col lg={4}></Col>
                            <Col lg={4} >
                                <SearchInput
                                    handleExpand={handleExpand}
                                    initialLastIconClass='last-input-icon cursor-hand'
                                    classMain='rounded-3 mb-2'
                                />
                            </Col>
                            <Col lg={3}></Col>
                            <Col lg={1} >

                                <LoginMenu handleShowOptionsUser={handleShowOptionsUser} />

                            </Col>
                        </Col>
                    </>

                ) : (

                    <Col>
                        <Col lg={12} className='d-flex justify-content-center align-items-center my-4 '>
                            <NavLink to={routesDirections.MAIN_ROUTE} state={{ originURL: location.pathname }}>
                                <Image
                                    id='logo'
                                    src={logo}
                                    alt='logo'
                                    className='logo-header'
                                    onClick={() => navigate(routesDirections.MAIN_ROUTE, { state: { originURL: location.pathname } })}
                                />
                            </NavLink>
                        </Col>

                        <Col lg={12} className='d-flex justify-content-center align-items-center '>
                            <Col lg={1} />
                            <div className='d-flex justify-content-center align-items-start mx-auto' style={{ width: '50%' }}>
                                <Col >
                                    <Menu />
                                </Col>
                                {/* <Col className="d-flex justify-content-center"> */}
                                {/* <button ref={storeButton} onClick={handleClickStore} className={`${buttonVariant} link-text-standard list-inline-item m-0`} > */}
                                {/* <span className='p-large-medium paragraph-category-text'> */}
                                {/* {translate("exclusive_header.store_title")} */}
                                {/* </span> */}
                                {/* </button> */}
                                {/* </Col> */}
                                <Col className="d-flex justify-content-center">
                                    <button ref={purchasesButton} className={`${buttonVariant} link-text-standard list-inline-item m-0`}
                                        onClick={handleClickMyPurchases}
                                    >
                                        <span className='p-large-medium paragraph-category-text'>
                                            {translate("exclusive_header.purchases_title")}
                                        </span>
                                    </button >
                                </Col >
                                <Col className="d-flex justify-content-center">
                                    <button ref={blogButton} onClick={handleClickBlog} className={`${buttonVariant} link-text-standard list-inline-item m-0`} >
                                        <span className='p-large-medium paragraph-category-text'>
                                            {translate("exclusive_header.blog_title")}
                                        </span>
                                    </button>
                                </Col>
                                <Col className="d-flex justify-content-center">
                                    <button ref={cartButton} className={`${buttonVariant} ${iconVariant} cursor-hand btn border-0 `} onClick={handleCartClick}>
                                        <CartWidget />
                                    </button>
                                </Col>

                                <Col className="d-flex justify-content-center" >
                                    <Icon name='ico-search' classMain={`${buttonVariant} ${iconVariant} `} onClick={handleExpand}></Icon>
                                </Col>

                            </div>
                            <Col lg={1} className='d-flex justify-content-center '>
                                <LoginMenu handleShowOptionsUser={handleShowOptionsUser} />
                            </Col>
                        </Col >
                    </Col >

                )}
            </Col >
        </Row >
    )
}

export default ExclusiveHeader